import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';

class CrntVisuallyHidden extends CrntElement {
  static {
    /** @internal */
    this.tagName = "crnt-visually-hidden";
  }
  render() {
    return html`<slot></slot>`;
  }
}

export { CrntVisuallyHidden };
